import React, { useEffect, useState } from "react";
/* import { useForm } from "react-hook-form";
import { FiChevronDown } from "react-icons/fi";
import LuckyGift from "../../assets/images/boxes.png";
import PulaLogo from "../../assets/images/pula-logo.svg";
import Button from "../../components/Buttons";
import { toast } from "react-toastify";
import Countdown from "../../util/countdown";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  requestOtpAction,
  requestOtpResetAction,
  submitFormAction,
  verifyOtpAction,
} from "../../redux/actions/app"; */

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

/*   const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      residentArea: "", // Set initial value to empty
    },
  });

  const requestOtpScreen = useSelector((state) => state.screens.requestOTP);
  const verifyOtpScreen = useSelector((state) => state.screens.verifyOTP);
  const submitFormScreen = useSelector((state) => state.screens.submitForm);

  const [showResend, setShowResend] = useState(false);
  const [showOTPInput, setShowOTPInput] = useState(false);
  const [haveValidOtp, setHaveValidOtp] = useState(false);

  useEffect(() => {}, []);

  useEffect(() => {
    if (requestOtpScreen.success) {
      toast.success("OTP Sent!");
      setShowOTPInput(true);
      setShowResend(false);
      dispatch(requestOtpResetAction());
    }
  }, [requestOtpScreen]);

  useEffect(() => {
    if (verifyOtpScreen.success) {
      // toast.success("Valid OTP!");
      setHaveValidOtp(true);
      dispatch(
        submitFormAction({
          first_name: getValues("firstName"),
          last_name: getValues("lastName"),
          email: getValues("email"),
          mobile: getValues("number"),
          area: getValues("residentArea"),
        })
      );
    }
  }, [verifyOtpScreen]);

  useEffect(() => {
    if (submitFormScreen.success) {
      // toast.success("Thank You!");
      navigate("/congratulations", { replace: true });
    }
  }, [submitFormScreen]);

  const resendOTPHandler = () => {
    console.log(getValues("number"));
    dispatch(requestOtpAction({ mobile: getValues("number") }));
  };

  const onSubmit = (data) => {
    console.log("Form Data", data);
    if (showOTPInput) {
      if (haveValidOtp) {
        // dispatch(
        //   submitFormAction({
        //     first_name: data.firstName,
        //     last_name: data.lastName,
        //     email: data.email,
        //     mobile: data.number,
        //     area: data.residentArea,
        //   })
        // );
      } else {
        dispatch(verifyOtpAction({ mobile: data.number, otp: data.otp }));
      }
    } else {
      dispatch(requestOtpAction({ mobile: data.number }));
    }
  };
 */
  return (
    <>
      <div className='bg-primary flex justify-center items-center lg:h-screen py-20'>
        <div className='container mx-auto px-4 w-full lg:w-3/5 xl:w-3/5'>
          <div className='grid grid-cols-1 lg:grid-cols-2'>
            <div className='bg-lightPink text-center px-6 pt-4 flex flex-col justify-between'>
              <div className='mb-12'>
                <img
                  src={PulaLogo}
                  className="w-auto md:w-40 mx-auto block"
                  alt="PULA LOGO"
                />
                <h1 className="text-primary pt-8 md:pb-2 xl:pb-2.5 text-2xl  sm:text-3xl md:text-[34px] font-medium capitalize">
                  PULA BAZAAR
                </h1>
                <h2 className="text-primary pb-7 text-2xl sm:text-3xl md:text-[34px] font-medium capitalize">
                  Lucky Draw Season 33
                </h2>
                <p className="font-normal text-gray50 text-sm sm:text-base mb-6">
                  Participate in our exciting lucky draw and stand a chance to
                  win amazing prizes. <br />
                  The lucky draw is open for only 2 days.
                </p>
                <p className="font-normal text-gray50 text-sm sm:text-base">
                  🎉 3 winners will be announced each day! 🎉
                </p>
              </div>
              <img
                src={LuckyGift}
                className="w-4/5 sm:w-11/12 md:w-auto mx-auto block"
                alt="lucky box"
              />
            </div>
            <div className="bg-white px-6 py-10 flex items-center justify-center h-full">
              <h3 className="text-center capitalize text-xl md:text-3xl font-semibold">
                Registrations Closed
              </h3>
              <div className="text-center hidden">
                <h2 className="capitalize text-3xl font-semibold mb-2">
                  join our contest
                </h2>
                <p className="text-sm">
                  Fill out this form to participate in the contest. <br />
                  Winners will be announced on 25th December 2024. <br />{" "}
                  Results will be posted on PULA, and winners will also be
                  contacted by the PULA Bazaar team via phone.
                </p>
              </div>

              <form onSubmit={handleSubmit(onSubmit)} className="pt-4 hidden">
                <div>
                  {/* First Name and last name */}
                  <div className="flex gap-4 mt-3">
                    <div className="w-full">
                      <label
                        htmlFor=""
                        className="capitalize text-gray50 font-normal text-xs"
                      >
                        first name
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        className={`${
                          errors.firstName
                            ? "border-red-600"
                            : "border-borderColor"
                        }
                   mt-1 w-full px-2 py-3.5 rounded-md border border-borderColor
                  text-black focus:outline-none text-base capitalize
                    focus:ring-1 focus:ring-primary-blue disabled:bg-gray-100`}
                        placeholder="first name"
                        {...register("firstName", {
                          required: "First name is required",
                          validate: (value) =>
                            /^[a-zA-Z\s]+$/.test(value) ||
                            "Only letters are allowed",
                        })}
                      />
                      {/* Error Message */}
                      {errors.firstName && (
                        <p className="text-red-500 text-sm">
                          {errors.firstName.message}
                        </p>
                      )}
                    </div>
                    <div className="w-full">
                      <label
                        htmlFor=""
                        className="capitalize text-gray50 font-normal text-xs"
                      >
                        last name
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        className={`${
                          errors.lastName
                            ? "border-red-600"
                            : "border-borderColor"
                        }
                    mt-1 w-full px-2 py-3.5 rounded-md border border-borderColor
                  text-black focus:outline-none text-base capitalize
                    focus:ring-1 focus:ring-primary-blue disabled:bg-gray-100`}
                        placeholder="last name"
                        {...register("lastName", {
                          required: "Last name is required",
                          validate: (value) =>
                            /^[a-zA-Z\s]+$/.test(value) ||
                            "Only letters are allowed",
                        })}
                      />
                      {/* Error Message */}
                      {errors.lastName && (
                        <p className="text-red-500 text-sm">
                          {errors.lastName.message}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Dropdown */}
                  <div className="mt-4">
                    {/* Label */}
                    <label
                      htmlFor="residentArea"
                      className="capitalize text-gray50 font-normal text-xs"
                    >
                      Nearby Neighborhood
                    </label>

                    <div className="relative">
                      {/* Dropdown */}
                      <select
                        id="residentArea"
                        {...register("residentArea", {
                          required: "Resident area is required",
                        })}
                        className={`w-full mt-1 px-2 py-3.5 rounded-md border border-borderColor ${
                          errors.residentArea
                            ? "border-red-500"
                            : "border-borderColor"
                        } text-black appearance-none focus:outline-none text-base
                    focus:ring-1 focus:ring-primary-blue disabled:bg-gray-100`}
                      >
                        <option value="" className="!text-grayB9" disabled>
                          Select an area
                        </option>
                        <option value="Akurdi">Akurdi</option>
                        <option value="Aundh">Aundh</option>
                        <option value="Baner">Baner</option>
                        <option value="Bavdhan">Bavdhan</option>
                        <option value="Bhosari">Bhosari</option>
                        <option value="Camp">Camp</option>
                        <option value="Chikhali">Chikhali</option>
                        <option value="Chinchwad">Chinchwad</option>
                        <option value="Deccan Gymkhana">Deccan Gymkhana</option>
                        <option value="Erandwane">Erandwane</option>
                        <option value="Hadapsar">Hadapsar</option>
                        <option value="Hinjawadi">Hinjawadi</option>
                        <option value="Kalyani Nagar">Kalyani Nagar</option>
                        <option value="Kharadi">Kharadi</option>
                        <option value="Koregaon Park">Koregaon Park</option>
                        <option value="Kothrud">Kothrud</option>
                        <option value="Magarpatta">Magarpatta</option>
                        <option value="Moshi">Moshi</option>
                        <option value="Nigdi">Nigdi</option>
                        <option value="Pashan">Pashan</option>
                        <option value="Pimpri">Pimpri</option>
                        <option value="Pimple Gurav">Pimple Gurav</option>
                        <option value="Pimple Saudagar">Pimple Saudagar</option>
                        <option value="Prabhat Road">Prabhat Road</option>
                        <option value="Ravet">Ravet</option>
                        <option value="Shivaji Nagar">Shivaji Nagar</option>
                        <option value="Talawade">Talawade</option>
                        <option value="Viman Nagar">Viman Nagar</option>
                        <option value="Wagholi">Wagholi</option>
                      </select>

                      {/* Icon */}
                      <FiChevronDown
                        className="text-grayB9 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                        size={20}
                      />
                    </div>

                    {/* Error Message */}
                    {errors.residentArea && (
                      <p className="text-red-500 text-sm">
                        {errors.residentArea.message}
                      </p>
                    )}
                  </div>
                  {/* Email ID */}
                  <div className="mt-4">
                    <label
                      htmlFor=""
                      className="capitalize text-gray50 font-normal text-xs"
                    >
                      Email ID
                    </label>
                    <input
                      type="email"
                      name="email"
                      className={`${
                        errors.email ? "border-red-600" : "border-borderColor"
                      }
                    mt-1 w-full px-2 py-3.5 rounded-md border 
                  text-black focus:outline-none text-base
                    focus:ring-1 focus:ring-primary-blue disabled:bg-gray-100`}
                      placeholder="Email id"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                          message: "Email is not valid",
                        },
                      })}
                    />
                    {errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.email.message}
                      </p>
                    )}
                  </div>

                  {/* Mobile Number and OTP */}
                  <div className="flex flex-col sm:flex-row gap-4 mt-4">
                    <div>
                      <label
                        htmlFor=""
                        className="capitalize text-gray50 font-normal text-xs"
                      >
                        WhatsApp Number
                      </label>
                      <input
                        type="tel"
                        id="number"
                        className={`${
                          errors.number
                            ? "border-red-600"
                            : "border-borderColor"
                        }
                   mt-1 w-full px-2 py-3.5 rounded-md border 
                  text-black focus:outline-none text-base
                    focus:ring-1 focus:ring-primary-blue disabled:bg-gray-100`}
                        placeholder="Mobile Number"
                        {...register("number", {
                          required: "Number is required",
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "Number must be 10 digits",
                          },
                        })}
                      />
                      {errors.number && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.number.message}
                        </p>
                      )}
                    </div>
                    {showOTPInput && (
                      <div>
                        <label
                          htmlFor=""
                          className="capitalize text-gray50 font-normal text-xs"
                        >
                          Enter OTP (check WhatsApp)
                        </label>
                        <input
                          type="tel"
                          id="otp"
                          className={`${
                            errors.otp ? "border-red-600" : "border-borderColor"
                          }
                      
                    mt-1 w-full px-2 py-3.5 rounded-md border 
                  text-black focus:outline-none text-base
                    focus:ring-1 focus:ring-primary-blue disabled:bg-gray-100`}
                          placeholder="OTP"
                          {...register("otp", {
                            required: "OTP is required",
                            pattern: {
                              value: /^[0-9]{4}$/,
                              message: "OTP must be 4 digits",
                            },
                          })}
                        />
                        {errors.otp && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.otp.message}
                          </p>
                        )}

                        {!haveValidOtp ? (
                          showResend ? (
                            showOTPInput && requestOtpScreen.loading ? (
                              <p className="text-gray50 flex gap-1.5 font-small">
                                Sending...
                              </p>
                            ) : (
                              <p
                                onClick={resendOTPHandler}
                                className="cursor-pointer capitalize text-primary font-medium hover:underline"
                              >
                                Resend OTP
                              </p>
                            )
                          ) : (
                            <small className="text-gray50 flex gap-1.5 font-small">
                              Resend OTP in{" "}
                              <Countdown
                                initialMinutes={0}
                                initialSeconds={30}
                                onTimeUp={() => {
                                  setShowResend(true);
                                }}
                              />
                            </small>
                          )
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-10">
                  {/* Submit Button */}
                  <Button
                    variant="fill"
                    loading={
                      requestOtpScreen.loading ||
                      submitFormScreen.loading ||
                      verifyOtpScreen.loading
                    }
                  >
                    {showOTPInput
                      ? haveValidOtp
                        ? "Submit"
                        : "Verify OTP"
                      : "Next"}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
